<template>
  <b-modal id="change-deadline-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" :ref="activityIndex ? `change-deadline-${activityIndex}` : 'change-deadline-modal'">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('voc.create_new_deadline') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-p adp-p__grey" style="margin-top: -16px;">{{ activity.name }}</div>
      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">{{ $t('catalog.set_new_deadline') }}</label>
        <my-date-picker @change="changeDateInterval($event)"
                        :dates="deadline"
                        :not-disable-range="true"
        >
        </my-date-picker>
      </div>
    </template>
    <template #modal-footer>
      <button class="btn adp-btn adp-btn__large"
              :class="{'disabled': !deadline}"
              :disabled="!deadline"
              style="margin-left: auto"
              @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import MyDatePicker from "../MyDatePicker";
import api from "../../api";

export default {
  name: "ChangeDeadlineModal",
  components: {
    'my-date-picker': MyDatePicker,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    activityIndex: {
      type: Number,
    }
  },
  data: function () {
    return {
      deadline: null,
    }
  },
  computed: {

  },
  methods: {
    onShow() {
      if (this.activity.deadline) {
        this.deadline = new Date(this.activity.deadline);
      } else {
        this.deadline = null;
      }
    },
    changeDateInterval(e) {
      if (e === null) {
        return;
      }
      this.deadline = e;
    },
    async save() {
      const data = {deadline: new Date(this.deadline).toLocaleString()};
      await api.setActivityDeadline(this.activity.id, data);

      if (this.activityIndex) {
        if (this.activityIndex === 1) {
          this.$bvModal.hide('change-deadline-modal');
          await this.$emit('deadline-updated');
        } else {
          this.$refs[`change-deadline-${this.activityIndex}`].isHidden = true;
          this.$refs[`change-deadline-${this.activityIndex}`].isClosing = true;
        }
      } else {
        this.$bvModal.hide('change-deadline-modal');
        await this.$emit('deadline-updated');
      }
    },
  },
}
</script>
